<details-section
  class="accuracy-feedback-details"
  [showDetails]="false"
  [title]="'simulationBuilder.ACCURACY_FEEDBACK_TITLE' | transloco"
>
  <div class="accuracy-feedback" [class.disabled]="toggleDisabled">
    <input
      qai-toggle-switch
      type="checkbox"
      [size]="'small'"
      [name]="'accuracy-feedback'"
      [checked]="toggleOn"
      [disabled]="toggleDisabled"
      [attr.aria-describedby]="'accuracy-feedback-description'"
      (change)="onToggle($event)"
    />

    <div class="accuracy-feedback__copy">
      <span class="accuracy-feedback__status">
        {{ 'simulationBuilder.' + statusLabelKey | transloco }}
      </span>
      <span
        class="accuracy-feedback__description"
        id="accuracy-feedback-description"
      >
        {{ 'simulationBuilder.' + descriptionKey | transloco }}
      </span>
    </div>
  </div>
</details-section>
